angular.module('mercury.modules.reports.voids')
.controller('ReportsVoidTimesCtrl', ["PosVoids", "reporttime", "$scope", "title", function(PosVoids, reporttime, $scope, title) {
  title.set('Voids Report');

  $scope.loading = PosVoids.getByInterval(reporttime.start(), reporttime.end(), reporttime.interval());
  $scope.loading.then(function(results) {
    angular.forEach(results, function(period) {
      period.notWastedAmount = period.voidAmount - period.wasteAmount;
      period.voidPercent = (period.invoices !== 0) ? (period.voidAmount / period.invoices) * 100 : 0;
      period.wastePercent = (period.invoices !== 0) ? (period.wasteAmount / period.invoices) * 100 : 0;
    });

    $scope.voids = results;
  });

  // Column definition for the main column graph
  $scope.voidsGraphColums = [
    {label: 'Period', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
    {label: 'Amount', type: 'number', key: 'notWastedAmount', filter: 'currency'}
  ];
}]);
